import React from "react";

export function PlayerAvatar({ player, club, size = 34, color }) {
  const initials = player ? `${player.firstName?.[0] || ""}${player.surname?.[0] || ""}`.toUpperCase() : "";
  const bg = color || club?.primary || "#333";
  const fg = club?.secondary || "#fff";
  return (
    <div
      className="rounded-full grid place-items-center font-display font-bold shrink-0"
      style={{ width: size, height: size, background: bg, color: fg, fontSize: size * 0.36, border: "1px solid rgba(255,255,255,0.12)" }}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
